export default function Banner() {
	return (
		<div className="banner-container">
			<div className="banner-text-container">
				<div className="banner-text">Chez vous, partout et ailleurs</div>
			</div>
		</div>
	);
}